/**
 * Visibilité de l’onglet Documents (BL-0470 / BL-0495).
 * Exige un projet enregistré, hors création, rôle U3500:READ et perso org GED/NAS activée (`initLU.enableGedNas`).
 */
export function u3121ShowDocumentsTab(params: {
  projectId?: string | null;
  isCreation: boolean;
  hasU3500Read: boolean;
  enableGedNas: boolean | undefined;
}): boolean {
  const { projectId, isCreation, hasU3500Read, enableGedNas } = params;
  return Boolean(projectId?.trim()) && !isCreation && hasU3500Read && enableGedNas === true;
}
